import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const PromoBanner = ({ user }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!user?.subscriptionExpires) {
      console.log('No subscription expiry date found');
      return;
    }

    // Calculate days since subscription started
    // Subscription expires date is 365 days after start, so subtract 365 days to get start date
    const subscriptionStartDate = new Date(user.subscriptionExpires);
    subscriptionStartDate.setDate(subscriptionStartDate.getDate() - 365);
    
    const today = new Date();
    const daysFromSubscription = Math.floor((today - subscriptionStartDate) / (1000 * 60 * 60 * 24));
    
    console.log('Subscription start date:', subscriptionStartDate);
    console.log('Days from subscription:', daysFromSubscription);
    
    // Show banner if within first 20 days
    setIsVisible(daysFromSubscription <= 20);
  }, [user]);

  const handleDismiss = () => {
    // Only hide for current session, will show again on next login
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="relative bg-blue-50 border-b border-blue-200">
      <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div className="pr-16 sm:text-center">
          <p className="font-medium text-blue-900">
            <span className="inline">
              Full Refund Offer: Tell 2 friends to use discount code <span className="font-bold">2ATIVAN</span> for $30 off. 
              If they purchase, send us their names/emails to support@criticalcases.com and we will offer you a full refund 
              within 20 days of your purchase! Offer valid for 20 days only.
            </span>
          </p>
        </div>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
          <button
            type="button"
            className="flex p-2 rounded-md hover:bg-blue-100 focus:outline-none"
            onClick={handleDismiss}
          >
            <X className="h-5 w-5 text-blue-500" aria-hidden="true" />
            <span className="sr-only">Dismiss</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;